import b from 'b_';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import cn from 'classnames';
import { FTBody, FTHeadline } from '../../Fuse';
import FuseInfoTooltip from '../../FuseControls/FuseTooltip/FuseInfoTooltip';
import './PolicySectionHeader.css';

const block = b.lock('PolicySectionHeader');

class PolicySectionHeader extends Component {
    static propTypes = {
        className: PropTypes.string,
        title: PropTypes.string.isRequired,
        tooltipText: PropTypes.string,
    };

    render = () => {
        const { title, className, children, tooltipText } = this.props;

        return <FTHeadline className={cn(block('SectionTopBar', { type: 'category' }), className)}>
            <FTBody className={block('SectionTitle')}>{title}</FTBody>
            {tooltipText ? <FuseInfoTooltip
                className={block('Info')}
            >{tooltipText}</FuseInfoTooltip> : null}
            {children}
        </FTHeadline>;
    }
}
export default PolicySectionHeader;
